import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-661902c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "linked-question"
}
const _hoisted_2 = { class: "linked-question-title" }
const _hoisted_3 = {
  key: 0,
  class: "linked-question-textarea"
}
const _hoisted_4 = {
  key: 1,
  class: "linked-question-wording"
}
const _hoisted_5 = { class: "question" }
const _hoisted_6 = { style: {"min-width":"250px"} }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "radio-button-group ml-4" }
const _hoisted_9 = { class: "radio" }
const _hoisted_10 = ["name", "value"]
const _hoisted_11 = { class: "radio-elmt mt-2 mb-2" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark-box" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark" })
], -1))
const _hoisted_13 = { class: "radio-text" }

export function render(_ctx, _cache) {
  const _component_Popover = _resolveComponent("Popover")
  const _component_FileUploader = _resolveComponent("FileUploader")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["radiobutton-horizontal", _ctx.validForm() ? 'answered' : ''])
  }, [
    (_ctx.question.linkedSubQuestion)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createTextVNode(_toDisplayString(_ctx.newLinkedWording) + " ", 1),
            _createVNode(_component_Popover, { popover: _ctx.obj }, null, 8, ["popover"])
          ]),
          (_ctx.question.linkedSubQuestion?.atcsQuestionTypeId==23)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.getResponse(_ctx.question.linkedSubQuestion)), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.getResponse(_ctx.question.linkedSubQuestion)), 1))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("h4", _hoisted_6, [
        _createTextVNode(_toDisplayString(_ctx.newWording) + " ", 1),
        _createVNode(_component_Popover, { popover: _ctx.obj }, null, 8, ["popover"])
      ]),
      (_ctx.question.description)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.question.description), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.question.responses, (option) => {
          return (_openBlock(), _createElementBlock("label", _hoisted_9, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              name: _ctx.uniqueIdName + this.question.id,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.selectedOption) = $event)),
              value: option.value
            }, null, 8, _hoisted_10), [
              [_vModelRadio, _ctx.selectedOption]
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("span", _hoisted_13, _toDisplayString(option.wording), 1)
            ])
          ]))
        }), 256))
      ])
    ]),
    _createVNode(_component_FileUploader, {
      class: "mt-3 mb-3",
      question: _ctx.question.atcsSubQuestions[0],
      "onUpdate:question": _cache[1] || (_cache[1] = $event => ((_ctx.question.atcsSubQuestions[0]) = $event)),
      isFileUploadOptional: _ctx.isFileUploadOptional,
      "onUpdate:isFileUploadOptional": _cache[2] || (_cache[2] = $event => ((_ctx.isFileUploadOptional) = $event)),
      onValidForm: _cache[3] || (_cache[3] = $event => (_ctx.validationFile(_ctx.i, $event)))
    }, null, 8, ["question", "isFileUploadOptional"])
  ], 2))
}